import { render, staticRenderFns } from "./SiderMenu.vue?vue&type=template&id=35f9f8fb&scoped=true&"
import script from "./SiderMenu.vue?vue&type=script&lang=js&"
export * from "./SiderMenu.vue?vue&type=script&lang=js&"
import style0 from "./SiderMenu.vue?vue&type=style&index=0&id=35f9f8fb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f9f8fb",
  null
  
)

export default component.exports